import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

import { withRoomContext } from '../RoomContext';
import Logger from '../Logger';

const logger = new Logger('Stats');

const styles = (theme) => ({
	root :
	{
		flex               : '0 0 auto',
		boxShadow          : 'var(--peer-shadow)',
		border             : 'var(--peer-border)',
		backgroundColor    : 'var(--peer-bg-color)',
		backgroundImage    : `url(${window.app_base_path}/svg/buddy.svg)`,
		backgroundPosition : 'bottom',
		backgroundSize     : 'auto 85%',
		backgroundRepeat   : 'no-repeat',
		zIndex             : 0,
	}
});

const Stats = (props) => {

	const {
		roomClient,
		classes,
		transports
	} = props;

	useEffect(() => {
		
		let poll;
		const interval = 5000;

		poll = setInterval(() => {
		
			roomClient.getTransportStats();
			roomClient.getProducerStats();
			roomClient.getConsumerStats();

		}, interval); // 定时请求返回 transport\producer\consumer 状态

		return () => clearInterval(poll);
	}, [ roomClient ]);

	return (
		<div
			className={classnames(
				classes.root
			)}
		>
			{JSON.stringify(transports)}
		</div>
	);
};

Stats.propTypes =
{
	roomClient          : PropTypes.any.isRequired,
	spacing             : PropTypes.number,
	classes             : PropTypes.object.isRequired,
	theme               : PropTypes.object.isRequired,
	transports          : PropTypes.object.isRequired
};

const makeMapStateToProps = () =>
{
	const mapStateToProps = (state) =>
	{
		return {
			transports          : state.transports
		};
	};

	return mapStateToProps;
};

export default withRoomContext(connect(
	makeMapStateToProps,
	null,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.transports === next.transports
			);
		}
	}
)(withStyles(styles, { withTheme: true })(Stats)));
